<template>
    <div class="addon-warning">
        <div v-if="addon.$type === SerializationType.CancellationInsurance">
            <p v-for="text in texts" :key="text">
                {{ text }}
            </p>
        </div>
        <div v-else-if="addon.$type === SerializationType.LuggageInsurance">
            <ul class="baggage-addon-warning-list">
                <li v-for="text in texts" :key="text">
                    {{ text }}
                </li>
            </ul>
        </div>
        <div v-else-if="addon.$type === SerializationType.TravelInsurance">
            <ul class="baggage-addon-warning-list">
                <li v-for="text in texts" :key="text">
                    {{ text }}
                </li>
            </ul>
        </div>

        <div class="addon-warning-disclaimer">
            <p>
                {{
                    t({
                        key: 'shared.do_you_want_to_add_X',
                        values: [title],
                    })
                }}
            </p>

            <p>
                <span class="addon-warning-price">
                    {{ getMoneyObjectAsString(addon.Price) }}
                </span>
                {{
                    t({
                        key: 'shared.for_the_whole_group',
                    })
                }}
            </p>
        </div>
    </div>
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, onMounted } from 'vue';
    import { AddonProduct, SerializationType } from '@/api/Cart/cart.interfaces';
    import { getAddonWarningTexts, getAddonTitle } from '@/helpers/addon';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { getMoneyObjectAsString } from '@shared/helpers/money';

    export default defineComponent({
        name: 'AddonWarning',
        methods: { t, getMoneyObjectAsString },
        props: {
            addon: { type: Object as () => AddonProduct, required: true },
        },
        setup({ addon }) {
            onMounted(() => {
                trackClarity(ClarityEvent.CHECKOUT_ADDON_WARNING);
            });
            const title = computed(() => getAddonTitle(addon.$type));
            const texts = computed(() => getAddonWarningTexts(addon.$type));

            return {
                title,
                texts,
                SerializationType,
            };
        },
    });
</script>
<style lang="scss" scoped>
    @use '@/styles/import' as *;

    .addon-warning {
        @include flex(column);
        gap: var(--spacing-12);

        p {
            margin: 0;
        }

        &-disclaimer {
            @include flex(column);
            gap: var(--spacing-24);
        }

        &-price {
            @include font-label-xl-bold();
            color: var(--color-neutral-70);
        }
    }
</style>
